module.exports = __webpack_public_path__ + "img/news_container.4f1d936f.jpg";